export const TRANSFER_FUNDS = "TRANSFER_FUNDS";
export const TRANSFER_FUNDS_SUCCESS = "TRANSFER_FUNDS_SUCCESS";
